export * from "./horizontal-feature-card-collection.component";
